export const DEFAULT_SECTION_COLOR = '#FFB800';
